import { connect } from 'react-redux';

import { MobileExtraVillages, IMobileExtraVillagesStoreProps, IMobileExtraVillagesOwnProps } from './ExtraVillages';
import { IState } from '../../../store';

export const mapStateToProps = ({ abGroup, villageData, userData }: IState): IMobileExtraVillagesStoreProps => {
  return {
    abGroup,
    user: userData,
    villageData,
  };
};

export const MobileExtraVillagesContainer = connect<IMobileExtraVillagesStoreProps, null, IMobileExtraVillagesOwnProps>(
  mapStateToProps,
)(MobileExtraVillages);
